import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Subscription } from 'rxjs/Subscription';

//Model
import { Url, User } from '../../../model/users.model';
import { RunNote } from '../../../model/notes.model';
import { ThemeSetting } from '../../../model/users.model';

//Service
import { UsersService } from '../../../services/users.service';
import { DispatchService } from '../../../services/dispatch.service';
import { BookingsService } from '../../bookings/bookings.service';
import { RunEventsService } from '../../../services/runevents.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-manifestevents',
  templateUrl: './manifestevents.component.html',
  styleUrls: ['./manifestevents.component.scss', '../../datatable.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DispatchService, UsersService, BookingsService, RunEventsService]
})
export class ManifestEventsComponent implements OnInit {
  @LocalStorage() url: Url;

  constructor(private _Activatedroute: ActivatedRoute,
              private svc_dispatch: DispatchService,
              private svc_member : UsersService,
              private _fb: FormBuilder,
              private modal: NgbModal,
              public router: Router,
              private svc_booking: BookingsService,
              private svc_runevents : RunEventsService,
              private svc_storage: LocalStorageService,
              private toastr: NotificationService,
              ) {}

  public run_events = [];
  public loadingIndicator:boolean = true;

  frm_run_event: FormGroup;
  frm_new_location: FormGroup;

  public sub: Subscription;
  public run_id = null;
  public run :any;
  public run_drivers=[];
  public run_equipments=[];
  public run_actions=[];
  public run_event:any;
  public locations = [];

  public fileStoragePath:string; 
  public user_id : number;
  public modalRef: NgbModalRef;

  public is_select_location :boolean = true;
  
  ngOnInit(): void {
    this.fileStoragePath = this.url.fileStorage;
    this.user_id = this.svc_storage.get('user').id;

    this.initializeForm();
    this.initLocationForm();
    this.getRunEvents();
  };

  initializeForm(){
    this.frm_run_event = this._fb.group({
      'id': null,
      'run_id': [this.run_id],
      'run_action_id': ['', Validators.required],
      'connote_site_id': [''],
      'location_id': [''],
      'start': ['', Validators.required],
      'end': ['', Validators.required],
      'created_by': [this.user_id],
      'odometer': [''],
      'hubometer1': [''],
      'hubometer2': [''],
      'hubometer3': [''],
      'hubometer4': [''],
      'hubometer5': [''],
      'hubometer6': [''],
      'hubometer7': [''],
      'run_plan_activity_id': [''],
      'load_check_id': [''],
      'notes': [''],
      'personnel_print_name': [''],
      'axle1': [''],
      'axle2': [''],
      'axle3': [''],
      'axle4': [''],
      'axle5': [''],
      'axle6': [''],
      'axle7': [''],
      'gross_weight': [''],
      'location_description':[''],
      'location_site': [null],
      // 'driver_id':[''],
      // 'equipment_id':[''],
      });
  }

  public getRunEvents(){
    this.sub = this._Activatedroute.params.subscribe(params => {
      this.run_id = params["id"];
    });
    
    this.svc_runevents.getRunEvents(this.run_id).subscribe(results=>{
      this.run_events = results['run_events'];
      this.run = results['run'][0];
      this.run_drivers = results['run_drivers'];
      this.run_equipments = results['run_equipments'];
      this.run_actions = results['run_actions'];
      this.locations = results['locations'];
      this.states = results['states'];

      this.viewEventDetails(this.run_events[0]);
      this.run_events[0].selected = true;

      setTimeout(() => { this.loadingIndicator = false; }, 500);
    });
  }

  public viewEventDetails(run_event){
    
    this.run_events.forEach(re => re.selected = false);
    run_event.selected = true;
    run_event.start = run_event.start.replace(' ', 'T');
    run_event.end = run_event.end.replace(' ', 'T');
    run_event.location_description ='';
    if(run_event.location_id){
      if(run_event.street_no) run_event.location_description += run_event.street_no + ' ';
      if(run_event.street) run_event.location_description += run_event.street + ' ';
      if(run_event.suburb) run_event.location_description += run_event.suburb + ' ';
      if(run_event.abbreviation) run_event.location_description += run_event.abbreviation + ' ';
      if(run_event.postal_code && run_event.postal_code !=0 ) run_event.location_description += run_event.postal_code + ' ';
    };
    this.run_event = run_event;
    this.frm_run_event.patchValue(run_event);

    if(document.getElementById('tDetails')){
      document.getElementById('tDetails').setAttribute('class', 'nav-link active');
      document.getElementById('eDetails').setAttribute('class', 'tab-pane active');
    };

    if(document.getElementById('tImages')){
      document.getElementById('tImages').setAttribute('class', 'nav-link');
      document.getElementById('eImages').setAttribute('class', 'tab-pane');
    };
  }

  public onSubmitRunEvent(run_event){
    run_event.created_by = this.user_id;
    
    this.svc_runevents.updateRunEvents(run_event).subscribe(result=>{
      if(result['error'] == true){
          this.toastr.showError(result['error_message'], 'Error in updating run event');
        }else{
          this.getRunEvents();
          this.toastr.showSuccess(result['message'], 'Run event successfully updated');
        }
    })

  };

  public goToRunDetails(){
    this.router.navigate(['/dispatch/manifestdetails', this.run_id ]);
  }

  public openModal(modal_id){
    this.modalRef = this.modal.open(modal_id, { container: '.app', backdrop: 'static', size:'lg'});
  }

  public location_settings       : any = {
    showSearchButton        : false,
    inputPlaceholderText    : 'Type key word on location to search',
    showCurrentLocation     : false
  };

  public changeLocation(selectedData: any) {
    
  }

  public loc :any;

  public userSettings: any = {
    showSearchButton: false,
    inputPlaceholderText: 'Type key word on location to search',
    showCurrentLocation: false
  };

  public updateLocation(new_location) {
    
    let location_description ='';
    if(this.loc){
      this.frm_run_event.controls.location_id.patchValue(this.loc.id);
      if(this.loc.street_no) location_description += this.loc.street_no + ' ';
      if(this.loc.street) location_description += this.loc.street + ' ';
      if(this.loc.suburb) location_description += this.loc.suburb + ' ';
      if(this.loc.abbreviation) location_description += this.loc.abbreviation + ' ';
      if(this.loc.postal_code && this.loc.postal_code !=0 ) location_description += this.loc.postal_code + ' ';
    }

    if(new_location.lat!='' && new_location.long!='' ){
      this.frm_run_event.controls.location_site.setValue(this.frm_new_location.value);
      if(new_location.street_no) location_description += new_location.street_no + ' ';
      if(new_location.street) location_description += new_location.street + ' ';
      if(new_location.suburb) location_description += new_location.suburb + ' ';
      if(new_location.state) location_description += new_location.state + ' ';
      if(new_location.postal_code) location_description += new_location.postal_code + ' ';

      //check if location already exists
      var search_locations = this.locations;
      search_locations = search_locations.filter(l=>l.lat == new_location.lat);
      
      if(search_locations.length){
        search_locations.forEach(loc=>{
          if(this.checkLocation(loc, this.frm_new_location.value)){
            this.frm_run_event.controls.location_site.setValue(null);
            this.frm_run_event.controls.location_id.setValue(loc.id);
          }else{
            this.frm_run_event.controls.location_id.setValue(null);
          }
        });
      }else{
        this.frm_run_event.controls.location_id.setValue(null);
      }
     
    }

    this.frm_run_event.controls.location_description.patchValue(location_description);
    
    this.loc = null;
    this.frm_new_location.reset();
    this.is_select_location = true;
    this.modalRef.close();

  }

  clearLocation(){
    this.loc = null;
    this.frm_run_event.controls.location_id.patchValue(null);
    this.frm_run_event.controls.location_description.patchValue('');
  }

  enableCreate(){
    this.is_select_location = false;
    this.loc = null;
  }

  enableSelect(){
    this.is_select_location = true;
    this.frm_new_location.reset();
  }

  initLocationForm() {
    
    this.frm_new_location = this._fb.group({
        id: [''],
        location_string: [''],
        lat: ['', Validators.required],
        long: ['', Validators.required],
        street_no: [''],
        street: [''],
        suburb: [''],
        state: [''],
        state_id: [''],
        postal_code: [''],
    });
  }

  pointdata: any;
  public mapObj: any;
  public mapLat: any;
  public mapLng: any;
  states :any;
  no_coordinates: boolean= true;


  locationSiteCallback(selectedData:any) {
    console.log(selectedData);
    
    const locCtrl = (<any>this.frm_new_location).controls;

    if (typeof selectedData === 'string' || selectedData instanceof String)
        this.pointdata = selectedData;
    else
        this.pointdata = JSON.stringify(selectedData);

    if (selectedData) {
      this.mapObj = JSON.parse(this.pointdata);
      this.mapObj = this.mapObj.data;
      this.mapLat = this.mapObj.geometry.location.lat;
      this.mapLng = this.mapObj.geometry.location.lng;
           
      locCtrl.lat.setValue(this.mapLat);
      locCtrl.long.setValue(this.mapLng);

      if(this.mapLat && this.mapLng){
        this.no_coordinates = false;
      }

      var arr = [];
      
      arr[0] = this.mapLat;
      arr[1] = this.mapLng;
     
      for(let result of this.mapObj.address_components){
        if (result.types == "street_number")
          locCtrl.street_no.setValue(result.short_name);
        if (result.types == "route")
          locCtrl.street.setValue(result.short_name);
        if ( result.types.includes("locality") ) 
          locCtrl.suburb.setValue(result.short_name);
        if ( result.types.includes("postal_code") ) 
          locCtrl.postal_code.setValue(result.short_name);

        if ( result.types.includes("administrative_area_level_1") ) {
          let stateId = null;
          this.states.forEach((item) => {
              if (item.abbreviation === result.short_name) {
                  stateId = item.id;
              }
          });
          locCtrl.state_id.setValue(stateId); 
          locCtrl.state.setValue(result.short_name);
        }
      }
      console.log(this.mapObj.address_components);
    }
  }
  
  public checkLocation(old_loc, new_loc){
    let location_exists = false;
    if(new_loc.lat == old_loc.lat){
      if(new_loc.long == old_loc.lng){
        if(new_loc.state == old_loc.state){
          if(new_loc.suburb == old_loc.suburb){
            if(new_loc.state == old_loc.state){
              if(new_loc.street == old_loc.street){
                if(new_loc.street_no == old_loc.street_no){
                  location_exists = true;
                }
              }
            }
          }
        }
      }
    }
    
    return location_exists;
  }

}
